import { css } from 'linaria';

export const kitchenGalleryButton = css`
  && {
    display: flex;
    width: max-content;
    margin: auto;

    @media (--to-desktop) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;
